import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=75e7696f&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75e7696f')) {
      api.createRecord('75e7696f', component.options)
    } else {
      api.reload('75e7696f', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=75e7696f&", function () {
      api.rerender('75e7696f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/components/Header.vue"
export default component.exports